import React, { useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ImageComponent from 'atoms/Image';
import { ButtonType, ContainedButton } from 'atoms/Buttons';
import {
  isOpenButtonText,
  getStoreDetails,
  addStoreToFavoriteHandler,
  removeStoreFromFavoriteHandler,
  selectStoreClickHandler,
  navigateToMenuPage,
  hoursText,
  callNearStore,
  formatNumber,
  hourService,
  toggleHoursView,
  collectionPointData,
} from '../SearchStoreUtilities/SearchStoreUtils';
import { storeOrderSchedulingUnavailable } from 'organisms/ScheduleOrder/ScheduleOrderUtils/ScheduleOrderUtils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { getDirectionURL, isFutureTime, isFutureDate, isAsapOrder } from 'common/utilities/utils';
import { getFacilities } from 'common/utilities/amenities';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { UserOrderContext } from 'context/context';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { ROUTE_URL, LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
import SEARCH_STORE_CONSTANTS from 'organisms/SearchStore/AU/Constants/SearchStoreConstants';
import { getFormattedDay, getFormattedTime } from 'common/sharedTemplates/dayHoursTemplates';
const { GET_DIRECTION, MORE_INFO, VIEW_MENU, SCHEDULE_ORDER, ORDER_NOW, BROWSE_MENU } = TRANSLATE_MAPPING_KEY;
const { Direction, AccordianArrow, phoneImg, FavoriteFillImage, FavoriteUnfillImage, InfoIcon } = IMAGE_PATH;
const { RESTAURANT } = ROUTE_URL;

export const gotoMenuPage = (
  userOrderStateDispatch,
  goToMenuObj,
  userOrderState,
  store,
  enableScheduleOrderFlag,
  enableClickCollectScheduleOrderFlag,
) => {
  const { history, dispatch, tenantId, userParams } = goToMenuObj;
  navigateToMenuPage(
    userOrderStateDispatch,
    history,
    dispatch,
    enableScheduleOrderFlag,
    enableClickCollectScheduleOrderFlag,
    {
      tenantId,
      userParams,
      userOrderState,
      store,
    },
  );
  userOrderStateDispatch({
    type: START_ORDER_CONSTANTS.FAV_STORE_NOT_IN_RADIUS,
    value: { showNotInRadiusError: false },
  });
  userOrderStateDispatch({
    type: START_ORDER_CONSTANTS.ORDER_MODE_BROWSE_MENU_CLICK,
    value: { orderModeBrowseMenuBtnClicked: true },
  });
};
const isFutureDateTimeOrder = store => {
  const isFutureTimeOrder = isFutureTime(store);
  const isFutureDateOrder = isFutureDate(store);
  return Boolean(isFutureDateOrder || isFutureTimeOrder);
};
export const setASAPOrderStorageData = (
  enableClickCollectScheduleOrderFlag,
  enableScheduleOrder,
  isStoreOpen,
  isAsapOrderFlag,
) => {
  return enableClickCollectScheduleOrderFlag || (enableScheduleOrder && (!isStoreOpen || !isAsapOrderFlag));
};
export const clickHandlerScheduleOrder = params => {
  const {
    event,
    buttonText,
    getStore,
    orderObj,
    goToMenuObj,
    enableScheduleOrder,
    enableClickCollectScheduleOrderFlag,
  } = params;
  const { store, userOrderStateDispatch, userOrderState, componentOptions } = orderObj;
  const isFutureTimeDate = isFutureDateTimeOrder(store);
  const isAsapOrderFlag = isAsapOrder(store);
  const updatedObj = { event, store, userOrderStateDispatch, userOrderState, componentOptions, isFutureTimeDate };
  const enableScheduleOrderFlag = enableScheduleOrder || enableClickCollectScheduleOrderFlag;
  const isStoreOpen = getStore?.open;
  if (buttonText === SCHEDULE_ORDER) {
    return selectStoreClickHandler({ ...updatedObj, flag: SCHEDULE_ORDER });
  } else {
    const isSetASAPOrderStorageData = setASAPOrderStorageData(
      enableClickCollectScheduleOrderFlag,
      enableScheduleOrder,
      isStoreOpen,
      isAsapOrderFlag,
    );
    if (isSetASAPOrderStorageData) {
      if (userOrderState?.reorderFlag?.fromReorderFlag) {
        userOrderStateDispatch({
          type: START_ORDER_CONSTANTS.SET_ORDER_NOW_REORDER,
          value: { showOrderNowReorder: true },
        });
        userOrderStateDispatch({
          type: START_ORDER_CONSTANTS.SET_SCHEDULE_ORDER_REORDER,
          value: { showScheduleOrderReorder: false },
        });
      } else {
        userOrderStateDispatch({
          type: START_ORDER_CONSTANTS.SET_ORDER_NOW,
          value: { showOrderNow: false },
        });
        userOrderStateDispatch({
          type: START_ORDER_CONSTANTS.SET_SCHEDULE_ORDER,
          value: { showScheduleOrder: true },
        });
      }
      userOrderStateDispatch({
        type: START_ORDER_CONSTANTS.SET_ASAP_SCHEDULING,
        value: { enableASAPScheduling: true },
      });
      if (enableClickCollectScheduleOrderFlag) {
        if (userOrderState?.reorderFlag?.fromReorderFlag) {
          userOrderStateDispatch({ type: START_ORDER_CONSTANTS.REORDER_MODAL_OPEN, value: { reorderModalOpen: true } });
          localStorage.setItem(LOCAL_STORAGE_KEYS.CURRENT_STORE_INFO_STORAGE, JSON.stringify(store));
          userOrderStateDispatch({ type: START_ORDER_CONSTANTS.SEARCH_ORDER_DATA, value: { showSearchStore: false } });
          userOrderStateDispatch({ type: START_ORDER_CONSTANTS.CURRENT_STORE_INFO, value: store });
        }
      }
    }
    Boolean(enableClickCollectScheduleOrderFlag || (enableScheduleOrder && buttonText === BROWSE_MENU)) &&
      gotoMenuPage(
        userOrderStateDispatch,
        goToMenuObj,
        userOrderState,
        store,
        enableScheduleOrderFlag,
        enableClickCollectScheduleOrderFlag,
      );
    Boolean(enableScheduleOrder && buttonText === ORDER_NOW) &&
      selectStoreClickHandler({ ...updatedObj, flag: ORDER_NOW });
  }
};

export const CommonContainedButton = params => {
  const {
    testid,
    getStore,
    buttonText,
    orderObj,
    goToMenuObj,
    enableClickCollectScheduleOrderFlag,
    enableScheduleOrder,
  } = params;
  const scheduleVariant = buttonText === SCHEDULE_ORDER ? ButtonType.tertiary : ButtonType.primary;
  return (
    <ContainedButton
      data-testid={testid}
      variant={scheduleVariant}
      onClickHandler={event =>
        clickHandlerScheduleOrder({
          event,
          buttonText,
          getStore,
          orderObj,
          goToMenuObj,
          enableClickCollectScheduleOrderFlag,
          enableScheduleOrder,
        })
      }
    >
      {translateWithI18Next(buttonText)}
    </ContainedButton>
  );
};

export const checkMoreInfoButton = (store, getStore, restrntPage, findAKFC) => {
  return (
    <>
      {findAKFC && (
        <div>
          <ContainedButton
            variant={'link dark'}
            data-testid='more-info'
            className='kfcmoreInfo'
            onClick={() => restrntPage(store)}
          >
            <img src={InfoIcon} alt='icon' className='KfcMoreinfo' />
            <span>{translateWithI18Next(MORE_INFO)}</span>
          </ContainedButton>
          <a
            className='kfcdirectionLink'
            href={getDirectionURL(getStore?.storeAddress)}
            target='_blank'
            rel='noreferrer noopener'
          >
            <span className='kfcdirection'>
              <img src={Direction} alt='direction' className='KfcDirectionIcon' />
              <span>{translateWithI18Next(GET_DIRECTION)}</span>
            </span>
          </a>
        </div>
      )}
    </>
  );
};

export const checkViewmoreInfo = (
  findAKFC,
  enableScheduleOrder,
  getStore,
  userOrderStateDispatch,
  goToMenuObj,
  userOrderState,
  store,
) => {
  return (
    <>
      {findAKFC && !enableScheduleOrder && (
        <ContainedButton
          variant={getStore?.storeOpen ? ButtonType.primary : ButtonType.tertiary}
          data-testid='view-menu'
          onClick={() => gotoMenuPage(userOrderStateDispatch, goToMenuObj, userOrderState, store)}
        >
          {translateWithI18Next(VIEW_MENU)}
        </ContainedButton>
      )}
    </>
  );
};

export const checkMoreinfoGetdirection = (isMapView, findAKFC, onClickMapHandler, store) => {
  return (
    <>
      {!isMapView && !findAKFC && (
        <div
          className='kfcdirectionLink map-link'
          data-testid='map-handler'
          onClick={() => onClickMapHandler(store?.id)}
        >
          <span className='kfcdirection'>
            <img src={Direction} alt='direction' className='KfcDirectionIcon' />
            <span>{translateWithI18Next(GET_DIRECTION)}</span>
          </span>
        </div>
      )}
    </>
  );
};

const SearchStoreCardDynamicComp = props => {
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { componentOptions: { web: { dispositionConfig: { enableScheduleOrder } = {} } = {} } = {} } =
    tenantReducer ?? {};
  const {
    store,
    isMapView,
    centerIndex,
    storeLength,
    loggedIn,
    onClickMapHandler,
    storeOpenBtnText,
    findAKFC,
    storeNumberFormat,
  } = props;

  const collectionPoint = Object.keys(store).length && collectionPointData(store?.availableCollectionPoints);
  let getStore = Object.keys(store).length && getStoreDetails(store, findAKFC, collectionPoint);
  const { customerId } = useSelector(data => data?.profileReducer);
  const { tenantId, componentOptions = {} } = useSelector(data => data?.tenantReducer);
  const enableClickCollectScheduleOrder = componentOptions?.web?.dispositionConfig?.enableClickCollectScheduleOrder;
  const allowScheduleOrderForDispositions = componentOptions?.web?.scheduledDelivery?.allowScheduleOrderForDispositions;
  const enableClickCollectScheduleOrderFlag =
    enableClickCollectScheduleOrder && allowScheduleOrderForDispositions?.includes(getStore?.dispositionService);
  const enableScheduleOrderFlag = enableScheduleOrder || enableClickCollectScheduleOrderFlag;
  const userParams = useSelector(data => data?.appStateReducer?.userStatus || {});
  const dispatch = useDispatch();
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const history = useHistory();
  const goToMenuObj = { history, dispatch, tenantId, userParams };

  const restrntPage = storeDetails => {
    const restName = storeDetails?.summary?.name.split(' ').join('-').toLowerCase();
    const postCode = store?.addresses?.[0]?.address?.pinCode;
    history.push({
      pathname: `${RESTAURANT}/${restName}/${postCode}`,
      state: { storeId: storeDetails?.id },
    });
    userOrderStateDispatch({ type: START_ORDER_CONSTANTS.DISPOSITION_DATA, value: { showDisposition: false } });
    userOrderStateDispatch({ type: START_ORDER_CONSTANTS.SEARCH_ORDER_DATA, value: { showSearchStore: false } });
    userOrderStateDispatch({ type: START_ORDER_CONSTANTS.SET_FIND_A_KFC_VIEW, value: { findAKFC: false } });
  };
  const orderObj = {
    enableScheduleOrderFlag,
    store,
    userOrderStateDispatch,
    userOrderState,
    componentOptions,
  };
  const isStoreOrderSchedulingUnavailable = storeOrderSchedulingUnavailable(
    store,
    enableScheduleOrderFlag,
    enableClickCollectScheduleOrderFlag,
    false,
  );
  const storeOpenCloseBtn =
    enableScheduleOrderFlag && isAsapOrder(store) && getStore?.storeOpen ? ORDER_NOW : BROWSE_MENU;

  return (
    <div
      id={`store-card-${store?.id}`}
      className={`store-card-container ${isMapView && 'map-card'}`}
      data-testid='store-card'
      key={store?.id}
    >
      <div className='store-card-main-content-container'>
        <div className='store-card-storename-dist-container'>
          <div className={`store-card-storename-dist-section ${isMapView && 'map-view'}`}>
            <div className='store-card-storename store-card-name'>{getStore?.storeName}</div>
            <div className='store-distance'>{getStore?.storeMile}</div>
          </div>
          {isMapView && <span className='store-index'>{`${centerIndex + 1} of ${storeLength}`}</span>}
        </div>
        <div className='store-card-content-container'>
          <div className='store-card-ordertypes'>{getStore?.storeOrderTypes}</div>
          <div className='store-card-store-address'>
            <span className='store-address'>{getStore?.storeAddress}</span>

            <div
              data-testid='toggle-hours'
              onClick={() => toggleHoursView(store?.id)}
              id={`hours-${store?.id}`}
              className='store-timing-msg'
            >
              <span>{getStore?.storeTimeMessage}</span>
              <span className='ml-2 caretIcon'>
                <ImageComponent id={`caret-${store?.id}`} srcFile={AccordianArrow} alt='caretIcon' />
              </span>
            </div>

            {/* Accordian for trading & delivery hrs */}
            <div id={`view-${store?.id}`} className='hours-view hoursHidden'>
              {!!hourService(getStore?.dispositionService, getStore?.storeTiming)?.storeTimingData?.length && (
                <div className='dispotion-hours-text'>{hoursText(store?.service)}</div>
              )}
              {hourService(getStore?.dispositionService, getStore?.storeTiming)?.storeTimingData?.map(item => {
                return (
                  <div key={item?.day}>
                    <div className='hours-text'>
                      <span className='day-details'>{getFormattedDay(item)}</span>
                      <span className='time-details'>{getFormattedTime(item)}</span>
                    </div>
                  </div>
                );
              })}

              {callNearStore(store) && (
                <div className='mt15'>
                  <span className='contact-icon'>
                    <ImageComponent id={`phoneImg-${store?.id}`} srcFile={phoneImg} alt='℡' />
                  </span>
                  <a data-testid='store-number' href={`tel:${callNearStore(store)}`} className='contact-info ml-2'>
                    {formatNumber(callNearStore(store), storeNumberFormat)}
                  </a>
                </div>
              )}
            </div>

            {checkMoreinfoGetdirection(isMapView, findAKFC, onClickMapHandler, store)}
            {checkMoreInfoButton(store, getStore, restrntPage, findAKFC)}
          </div>

          <div className='facilities'>
            {getFacilities(store)?.map(item => {
              return (
                <ImageComponent
                  key={item?.key}
                  data-testid=''
                  srcFile={item?.image}
                  alt={item?.label}
                  className='facility-img'
                  title={item?.label}
                />
              );
            })}
          </div>
        </div>
        <div className='search-store-card-button'>
          {loggedIn && (
            <ImageComponent
              data-testid='favorite-img'
              srcFile={store?.isFavoriteStore ? FavoriteFillImage : FavoriteUnfillImage}
              alt={'favorite'}
              className='favorite-img'
              onClick={() =>
                store?.isFavoriteStore
                  ? removeStoreFromFavoriteHandler(store, dispatch, tenantId, customerId)
                  : addStoreToFavoriteHandler(store, dispatch, tenantId, customerId)
              }
            />
          )}
          {checkViewmoreInfo(
            findAKFC,
            enableScheduleOrderFlag,
            getStore,
            userOrderStateDispatch,
            goToMenuObj,
            userOrderState,
            store,
          )}
          {!findAKFC && !enableScheduleOrderFlag && (
            <ContainedButton
              data-testid='schedule-order'
              variant={ButtonType.primary}
              onClickHandler={event =>
                getStore?.storeOpen
                  ? selectStoreClickHandler({ event, store, userOrderStateDispatch, userOrderState, componentOptions })
                  : gotoMenuPage(userOrderStateDispatch, goToMenuObj, userOrderState, store)
              }
            >
              {isOpenButtonText(findAKFC, getStore?.storeOpen, storeOpenBtnText)}
            </ContainedButton>
          )}
          {enableScheduleOrderFlag &&
            CommonContainedButton({
              testid: SEARCH_STORE_CONSTANTS?.ORDER_NOW,
              getStore: getStore,
              buttonText: storeOpenCloseBtn,
              orderObj: orderObj,
              goToMenuObj: goToMenuObj,
              enableClickCollectScheduleOrderFlag: enableClickCollectScheduleOrderFlag,
              enableScheduleOrder,
            })}
          {enableScheduleOrderFlag &&
            isFutureDateTimeOrder(store) &&
            !isStoreOrderSchedulingUnavailable &&
            CommonContainedButton({
              testid: SEARCH_STORE_CONSTANTS.ORDER_SCHEDULE,
              getStore: getStore,
              buttonText: SCHEDULE_ORDER,
              orderObj: orderObj,
              goToMenuObj: goToMenuObj,
              enableClickCollectScheduleOrderFlag: enableClickCollectScheduleOrderFlag,
              enableScheduleOrder,
            })}
        </div>
      </div>
    </div>
  );
};

const SearchStoreCardDynamic = React.memo(SearchStoreCardDynamicComp);
export default SearchStoreCardDynamic;
